import React, {} from 'react';
import {
  BrowserRouter,
  Routes,
  Route
} from 'react-router-dom';

import application from 'application';

import useStartupTheme from 'generics/hooks/use-startup-theme';

import RouteBridge from 'root/route-bridge';
import AuthenticationCallback from 'root/authentication-callback';
import LoggedOutView from 'root/logged-out-view';

import Authorizer from 'root/authorizer';
import StartupView from 'root/startup-view';
import AppointmentView from 'root/appointment-view/react';
import MeetingView from 'root/meeting-view/react';

import './index.scss';

function StartupRoutes(props) {

  useStartupTheme(props.startup, application.system.getFontFamilies());

  function renderStartupPathContent() {

    const authorizerProperties = {
      if () {
        return application.isAuthenticated() === true;
      },
      then(history, urlParameters) {

      },
      else() {
        // window.location.href = application.getAuthenticatorURL();
      }
    };
    const humanFriendlyId = application.getHumanFriendlyStartupIdFromHost();

    const startupViewProperties = {
      patternPrefix: '/',
      humanFriendlyId
    };

    return <Authorizer name="StartupView" {...authorizerProperties}>
      <StartupView {...startupViewProperties} />
    </Authorizer>;

  }

  function renderAuthenticationCallbackRoute() {

    const routeProperties = {
      path: '/authentication-callback',
      element: <AuthenticationCallback />
    };

    return <Route {...routeProperties}></Route>;

  }

  function renderLoggedOutRoute() {

    const routeProperties = {
      path: '/logged-out',
      element: <LoggedOutView />
    };

    return <Route {...routeProperties}></Route>;

  }

  function renderAppointmentRoute() {

    const routeProperties = {
      path: '/appointments/:appointmentId',
      element: <AppointmentView />
    };

    return <Route {...routeProperties}></Route>;

  }

  function renderMeetingRoute() {

    const routeProperties = {
      path: '/meetings/:meetingId',
      element: <MeetingView />
    };

    return <Route {...routeProperties}></Route>;

  }

  function renderStartupPathRoute() {

    const routeProperties = {
      path: '/*',
      element: renderStartupPathContent()
    };

    return <Route {...routeProperties}></Route>;

  }

  function renderStartupHostRouter() {

    return <BrowserRouter>
      <RouteBridge />
      <Routes>
        {renderAuthenticationCallbackRoute()}
        {renderLoggedOutRoute()}
        {renderAppointmentRoute()}
        {renderMeetingRoute()}
        {renderStartupPathRoute()}
      </Routes>
    </BrowserRouter>;

  }

  return renderStartupHostRouter();
}

export default StartupRoutes;